var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('DonutChart',{attrs:{"data":_vm.items}}),_c('DonutChart',{attrs:{"data":_vm.items}}),_c('DonutChart',{attrs:{"data":_vm.items}})],1),_c('ReservationsTable',{attrs:{"title":"Items Table","headers":_vm.headers,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }